import ScrollToTop from '../Components/ScrollToTop'
import Footer from '../Components/Footer/Footer'
import HeroSection7 from '../Components/HeroSection7/index7'
import InfoSection6 from '../Components/Infosection6/Index6'
import { homeObjOne6 } from '../Components/Infosection6/Data6'
import DecoreMasonry from '../Components/Masonry/DecoreMasonry'

const Decore = () => {
  return (
    <>
      <ScrollToTop />
      <HeroSection7 />
      <InfoSection6 {...homeObjOne6} />
      <DecoreMasonry />
      <Footer />
    </>
  )
}

export default Decore